import ClientService from '../../services/client-service';
import getContactListDataQuery from '../../graphql/query/get-contact-list-data.graphql';
import getContactCompanyByDomainDataQuery from '../../graphql/query/get-contact-company-by-domain-data.graphql';
import getContactPersonByEmailDataQuery from '../../graphql/query/get-contact-person-by-domain-data.graphql';
import saveContactListDataMutation from '../../graphql/mutation/save-contact-list-data.graphql';
import deleteContactListMutation from '../../graphql/mutation/delete-contact-list.graphql';

export default class ContactListApi {
  public static getContactListData(payload: ActionPayload): Promise<ActionResponse | null> {
    return ClientService.sendGraphqlQueryRequest(getContactListDataQuery, payload);
  }

  public static getContactCompanyByDomainData(payload: ActionPayload): Promise<ActionResponse | null> {
    return ClientService.sendGraphqlQueryRequest(getContactCompanyByDomainDataQuery, payload);
  }

  public static getContactPersonByEmailData(payload: ActionPayload): Promise<ActionResponse | null> {
    return ClientService.sendGraphqlQueryRequest(getContactPersonByEmailDataQuery, payload);
  }

  public static saveContactListData(payload: ActionPayload): Promise<ActionResponse | null> {
    return ClientService.sendGraphqlMutationRequest(saveContactListDataMutation, payload);
  }

  public static deleteContactList(payload: ActionPayload): Promise<ActionResponse | null> {
    return ClientService.sendGraphqlMutationRequest(deleteContactListMutation, payload);
  }
}
